import React from "react";
import { UpsellPageRenderer } from "./components/pages/UpsellPageRenderer";
import { useUpsellApi } from "./hooks/useUpsellApi";
import { useUpsellStyles } from "./hooks/useUpsellStyles";
import { useUpsellUiState } from "./hooks/useUpsellUiState";
import { NavHeader } from "./components/molecules/NavHeader";

function App() {
  const { data, isLoading, error } = useUpsellApi();

  useUpsellStyles();

  const hasCountdown =
    data?.layout_variant === "multiple_products" &&
    Array.isArray(data?.multiple_products_sections) &&
    data.multiple_products_sections.some(
      (s) => s.acf_fc_layout === "shipping_notice_countdown",
    );

  const { countdownText, isCountdownExpired } = useUpsellUiState({
    hasCountdown: !!hasCountdown,
  });

  const heroSection = Array.isArray(data?.multiple_products_sections)
    ? data.multiple_products_sections.find(
        (section) =>
          section.acf_fc_layout === "hero_2_columns" ||
          section.acf_fc_layout === "hero_1_column",
      )
    : null;

  const shippingSection = Array.isArray(data?.multiple_products_sections)
    ? data.multiple_products_sections.find(
        (section) => section.acf_fc_layout === "shipping_notice_countdown",
      )
    : null;

  const offerProductsSection = Array.isArray(data?.multiple_products_sections)
    ? data.multiple_products_sections.find(
        (section) => section.acf_fc_layout === "offer_products_section",
      )
    : null;

  const reviewsSection = Array.isArray(data?.multiple_products_sections)
    ? data.multiple_products_sections.find(
        (section) => section.acf_fc_layout === "reviews_section",
      )
    : null;

  const themeVars: React.CSSProperties = {
    ["--main" as string]: data?.colors?.main_text_color ?? "#000000ba",
    ["--gray" as string]: data?.colors?.grey_text_color ?? "#0000007d",
    ["--light-gray" as string]:
      data?.colors?.tracker_bar_bg_color ?? "#0000001a",
    ["--white" as string]: data?.colors?.light_bg_color ?? "#ffffff",
    ["--background" as string]: data?.colors?.body_bg_color ?? "#f9f9f4",
    ["--secondary" as string]: data?.colors?.secondary_bg_color ?? "#eff8df",
    ["--primary" as string]: data?.colors?.primary_bg_color ?? "#326e22",
    ["--discount-badge" as string]:
      heroSection?.data?.discount_badge_bg_color ?? "#326e22",
    ["--shipping-background" as string]:
      shippingSection?.data?.timer_bg_color ?? "#19433A",
    ["--product-bg" as string]:
      offerProductsSection?.data?.prod_card_header_bg_color ?? "#9BDFFF",
    ["--product-bg-popular" as string]:
      offerProductsSection?.data?.prod_card_header_popular_bg_color ??
      "#FF7A03",
    ["--accent-bg" as string]:
      reviewsSection?.data?.bg_accent_color ?? "#00000007",
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-100" style={themeVars}>
        <div id="app">
          <main className="upsell-container">
            <div style={{ padding: "2rem", textAlign: "center" }}>
              Loading...
            </div>
          </main>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen bg-slate-100" style={themeVars}>
        <div id="app">
          <main className="upsell-container">
            <div style={{ padding: "2rem", textAlign: "center" }}>
              {error?.message ?? "No data available"}
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100" style={themeVars}>
      <div id="app">
        <NavHeader logo={data.general_settings?.logo} />
        <UpsellPageRenderer
          data={data}
          countdownText={countdownText}
          isCountdownExpired={isCountdownExpired}
        />
      </div>
    </div>
  );
}

export default App;
